import {makeStyles} from "@material-ui/core/styles";

export const useTableWithCheckboxesHeadStyles = makeStyles(() => ({
    root: {
        cursor: 'initial !important'
    }
}));
